var ezdia;
(function (ezdia) {
    var SHOW_HISTORY_ID_PREFIX = ezdia.config.IDS.SHOW_HISTORY_PREFIX;
    var SHOW_PARENTVALUE_PREFIX = ezdia.config.IDS.SHOW_PARENTVALUE_PREFIX;
    function videoHelpHTML(column) {
        var _a = column.config, config = _a === void 0 ? {} : _a;
        var htmlContent = '';
        if (config.videoHelp) {
            htmlContent = "<i class=\"fa fa-video-camera form-control-video-feedback\" onclick=\"youTubePopup('Video Help', '" + config.videoHelp + "')\"></i>";
        }
        return htmlContent;
    }
    function helpInfoHTML(helpInfo) {
        return helpInfo
            ? "<span\n        tabindex=\"0\"\n        role=\"button\"\n        data-placement=\"right auto\"\n        class=\"glyphicon glyphicon-info-sign form-control-feedback\"\n        data-helper=\"helper\"\n        data-content=\"" + helpInfo + "\"></span>"
            : "";
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function helperTextTypeHTML(helperTextType) {
        return helperTextType
            ? "<p class=\"ez-helper-text-bottom\">" + helperTextType + "</p>"
            : "";
    }
    function getAppendOptionMarkup(colObj) {
        var column = colObj.column;
        var edittype = column.edittype, name = column.name, config = column.config;
        var showAppend = config.showAppend === true;
        var htmlContent = '';
        if (showAppend || (config.showAppend !== false && edittype === 'tag')) {
            htmlContent = "<li for=\"" + name + "_append\"><label><i class=\"fa fa-plus-circle\"></i>Append\n        <input\n          type=\"checkbox\"\n          id=\"" + name + "_sys_append\"\n          name=\"" + name + "_append\"\n          value=\"true\"\n          data-id=\"" + name + "\"\n          data-actiontype=\"append\"\n          data-field=\"" + edittype + "\"\n          data-checkbox=\"devfieldOption\">\n        <i class=\"fa fa-check text-success\"></i></label>\n      </li>";
        }
        return htmlContent;
    }
    function getDeleteOptionMarkup(colObj) {
        var column = colObj.column, value = colObj.value;
        var edittype = column.edittype, name = column.name, config = column.config, values = column.values;
        var htmlContent = '';
        if (config.showDelete !== false &&
            (value || value === '0' || values || values === '0')) {
            htmlContent = "<li for=\"" + name + "_delete\"><label><i class=\"fa fa-trash\"></i>Delete\n        <input\n          type=\"checkbox\"\n          id=\"" + name + "_sys_delete\"\n          name=\"" + name + "_delete\"\n          value=\"true\"\n          data-id=\"" + name + "\"\n          data-actiontype=\"delete\"\n          data-field=\"" + edittype + "\"\n          data-checkbox=\"devfieldOption\">\n        <i class=\"fa fa-check text-success\"></i></label>\n      </li>";
        }
        return htmlContent;
    }
    function getFieldOptionsIconMarkup() {
        return "\n      <i class=\"fa fa-plus-circle stack-append\" title=\"Append the value\"></i>\n      <i class=\"fa fa-trash stack-delete\" title=\"Delete the value\"></i>\n    ";
    }
    function fieldOptionsMarkup(colObj) {
        var column = colObj.column;
        var editable = column.editable, name = column.name;
        if (!editable) {
            return '';
        }
        return "<div class=\"field-option\">\n      <a href=\"javascript:void\" data-toggle=\"dropdown\">\n        <i class=\"fa fa-circle\"></i>\n        <i class=\"fa fa-circle\"></i>\n        <i class=\"fa fa-circle\"></i>\n      </a>\n      <ul class=\"dropdown-menu\">\n        " + getAppendOptionMarkup(colObj) + "\n        " + getDeleteOptionMarkup(colObj) + "\n        <li data-action=\"reset\" data-name=\"" + name + "\"><a class=\"disabled\"><i class=\"fa fa-undo\"></i>Undo</a></li>\n      </ul>\n    </div>";
    }
    function showHistoryLinkMarkup(colObj) {
        var _a = colObj.column, showhistory = _a.config.showhistory, editable = _a.editable, idSuffix = colObj.idSuffix;
        var htmlContent = '';
        if (editable && showhistory) {
            htmlContent = "<a class=\"btn btn-link btn-xs\" id=\"" + SHOW_HISTORY_ID_PREFIX + idSuffix + "\" href=\"javascript:void(0)\">\n        <span class=\"active\"></span>Previous version\n      </a>";
        }
        return htmlContent;
    }
    function showParentValueLinkMarkup(colObj) {
        var _a = colObj.column, _b = _a.config, showParentValue = _b.showParentValue, parentFieldName = _b.parentFieldName, editable = _a.editable, idSuffix = colObj.idSuffix;
        var htmlContent = '';
        if (editable && showParentValue) {
            htmlContent = "<a class=\"btn btn-link btn-xs\" data-parentFieldName =" + parentFieldName + " id=\"" + SHOW_PARENTVALUE_PREFIX + idSuffix + "\" href=\"javascript:void(0)\">\n        <span class=\"active\"></span>Review Parent Value\n      </a>";
        }
        return htmlContent;
    }
    function rowMarkup(colObj) {
        var column = colObj.column, idSuffix = colObj.idSuffix, content = colObj.content;
        var label = column.label, id = column.id, name = column.name, required = column.required, helperText = column.helperText, classes = column.classes;
        return "<div\n      data-row=\"row\"\n      id=\"" + id + "__row\"\n      class=\"form-group " + classes + "\">\n      <div class=\"control-label\" for=\"" + name + "\">\n        " + label + (required ? '*' : '') + "\n        " + videoHelpHTML(column) + "\n      </div>\n      <div data-row=\"input\" class=\"inputs\" id=\"" + id + "__input\">\n        " + getFieldOptionsIconMarkup() + "\n        " + content + "\n        " + helpInfoHTML(helperText) + "\n\n        <div id=\"ez-js__acw__" + idSuffix + "\" class=\"action-link-wrapper\" data-row=\"actionLink\">\n          " + showHistoryLinkMarkup(colObj) + "\n          " + showParentValueLinkMarkup(colObj) + "\n        </div>\n      </div>\n      " + fieldOptionsMarkup(colObj) + "\n    </div>";
    }
    function tabDDBtnMarkup(type) {
        return "<div class=\"nav-pills-arrow-" + type + " hide\" data-arrow=\"" + type + "\">\n      <a href=\"javascript:void(0)\"  data-toggle=\"dropdown\">\n          <i class=\"fa fa-circle\"></i>\n          <i class=\"fa fa-circle\"></i>\n          <i class=\"fa fa-circle\"></i>\n      </a>\n      <ul class=\"dropdown-menu\"></ul>\n    </div>";
    }
    function getTabItems(_a) {
        var id = _a.id, label = _a.label, tabActiveCls = _a.tabActiveCls;
        return "<li class=\"" + tabActiveCls + "\"><a href=\"#" + id + "\">" + label + "</a></li>";
    }
    function tabMarkup(tabs) {
        return "<div class=\"ez-scroll-nav-pills hide\" id=\"ez-scroll-nav-pills\">\n      " + tabDDBtnMarkup('left') + "\n      <div data-nav=\"scroll\" class=\"ez-nav-scroll-inner\">\n        <ul class=\"nav ez-nav-pills\">" + tabs + "</ul>\n      </div>\n      " + tabDDBtnMarkup('right') + "\n  </div>";
    }
    function groupMarkup(_a) {
        var id = _a.id, label = _a.label, htmlContent = _a.htmlContent;
        var idSuffix = id.split('__').pop();
        return "<div id=\"" + id + "\" class=\"panel ez-form-fields-grp\" data-group=\"form fields\">\n      <div id=\"ez-grp-heading__" + idSuffix + "\" class=\"panel-heading\" data-toggle=\"collapse\" href=\"#ez-grp-body__" + idSuffix + "\">\n        <i class=\"fa fa-angle-up\"></i>" + label + "\n      </div>\n      <div id=\"ez-grp-body__" + idSuffix + "\" class=\"panel-body collapse in\">\n        " + htmlContent.join('') + "\n      </div>\n    </div>";
    }
    function groupsWithTabsMarkup(_a) {
        var e_1, _b;
        var colGroup = _a.colGroup, groupArrayObj = _a.groupArrayObj, groupIdMap = _a.groupIdMap;
        var groupHtmlContentArray = [];
        var tabsHtmlContentArray = [];
        var tabActiveCls = 'active';
        try {
            for (var colGroup_1 = __values(colGroup), colGroup_1_1 = colGroup_1.next(); !colGroup_1_1.done; colGroup_1_1 = colGroup_1.next()) {
                var label = colGroup_1_1.value.label;
                var htmlContent = groupArrayObj[label];
                var id = groupIdMap[label];
                if (htmlContent.length) {
                    var grpHtmlContent = groupMarkup({ id: id, label: label, htmlContent: htmlContent });
                    groupHtmlContentArray.push(grpHtmlContent);
                    var tabHtmlContent = getTabItems({ id: id, label: label, tabActiveCls: tabActiveCls });
                    tabsHtmlContentArray.push(tabHtmlContent);
                    tabActiveCls = '';
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (colGroup_1_1 && !colGroup_1_1.done && (_b = colGroup_1.return)) _b.call(colGroup_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var tabsHtmlContent = tabMarkup(tabsHtmlContentArray.join(''));
        return {
            grpHTMLContent: groupHtmlContentArray.join(''),
            tabsHtmlContent: tabsHtmlContent
        };
    }
    var templates;
    (function (templates) {
        templates.form = {
            rowMarkup: rowMarkup,
            groupsWithTabsMarkup: groupsWithTabsMarkup
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
